var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 34.1466L4.26854 27.5146C3.33627 26.6225 3.33627 25.1846 4.26854 24.2925C5.2008 23.4004 6.70347 23.4004 7.63574 24.2925L10.132 26.6812V14.2916C10.132 13.2704 10.9968 12.437 12.0701 12.437C13.1373 12.437 14.0083 13.2645 14.0083 14.2916V20.906L18.6267 21.7101C21.2456 22.2207 22.8709 22.7724 22.6808 25.5895L21.9448 33.6301",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22613 19.48C-0.0753751 15.2543 -0.0753751 8.40035 4.22613 4.17469C8.52025 -0.05823 15.4853 -0.05823 19.7794 4.17469C24.0735 8.40035 24.0735 15.2543 19.7794 19.48",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83826 16.84C3.74662 14.0231 3.74662 9.44971 6.83826 6.63274C9.92989 3.81578 14.9492 3.81578 18.0408 6.63274C21.1324 9.44971 21.1324 14.0231 18.0408 16.84",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57619 15.0799C6.68814 13.2704 6.68814 10.3265 8.57619 8.51701C10.4642 6.70755 13.5361 6.70755 15.4241 8.51701C17.3122 10.3265 17.3122 13.2704 15.4241 15.0799",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionQueue);
export default __webpack_public_path__ + "static/media/ActionQueue.308bd5633b684f7ec657e4f397ab465f.svg";
export { ForwardRef as ReactComponent };